"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericFormats = exports.cancelReport = exports.reportColumns = exports.dateFormats = exports.getReportData = exports.reportDel = exports.reportData = exports.reportSave = exports.reportList = exports.treeNodeChildren = exports.setBaseUrl = void 0;
var nform_1 = require("./nform");
var utils_1 = require("./utils");
var baseUrl;
function setBaseUrl(url) {
    baseUrl = url;
}
exports.setBaseUrl = setBaseUrl;
function sendHttpRequest(endPoint, body, properties) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return __awaiter(this, void 0, void 0, function () {
        var credentials, base64, AuthHeader, response, text, message;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    credentials = ((_b = (_a = properties === null || properties === void 0 ? void 0 : properties.Credentials) === null || _a === void 0 ? void 0 : _a.Simple) === null || _b === void 0 ? void 0 : _b.Userlogin) + ':' + (0, utils_1.escapeString)((_d = (_c = properties === null || properties === void 0 ? void 0 : properties.Credentials) === null || _c === void 0 ? void 0 : _c.Simple) === null || _d === void 0 ? void 0 : _d.Password);
                    base64 = Buffer.from(credentials).toString('base64');
                    AuthHeader = {
                        Authorization: 'Basic ' + base64,
                        'Grpc-Metadata-tabulaini': (properties === null || properties === void 0 ? void 0 : properties.Tabulaini) || '',
                    };
                    if ((_f = (_e = properties === null || properties === void 0 ? void 0 : properties.Credentials) === null || _e === void 0 ? void 0 : _e.Openid) === null || _f === void 0 ? void 0 : _f.Token) {
                        AuthHeader.Authorization = 'Bearer ' + ((_h = (_g = properties === null || properties === void 0 ? void 0 : properties.Credentials) === null || _g === void 0 ? void 0 : _g.Openid) === null || _h === void 0 ? void 0 : _h.Token);
                    }
                    return [4 /*yield*/, fetch(baseUrl + '/' + endPoint, {
                            method: 'POST',
                            headers: __assign({ contentType: 'application/json; charset=utf-8', dataType: 'json' }, AuthHeader),
                            body: body,
                        })];
                case 1:
                    response = _j.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.text()];
                case 2:
                    text = _j.sent();
                    message = "An error has occured: ".concat(response.status, ", a ").concat(text);
                    throw new Error(message);
                case 3: return [2 /*return*/, response.json()];
            }
        });
    });
}
function treeNodeChildren(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.TreeNodeChildrenRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('TreeNodeChildren', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.TreeNodeChildrenRs.fromObject(res)];
            }
        });
    });
}
exports.treeNodeChildren = treeNodeChildren;
function reportList(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.ReportListRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('ReportList', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.ReportListRs.fromObject(res)];
            }
        });
    });
}
exports.reportList = reportList;
function reportSave(req) {
    return __awaiter(this, void 0, void 0, function () {
        var reqObj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    reqObj = nform_1.priority.netitems.nrest.ReportSaveRq.toObject(req);
                    body = JSON.stringify(reqObj);
                    return [4 /*yield*/, sendHttpRequest('ReportSave', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.ReportSaveRs.fromObject(res)];
            }
        });
    });
}
exports.reportSave = reportSave;
function reportData(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.ReportDataRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('ReportData', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.ReportDataRs.fromObject(res)];
            }
        });
    });
}
exports.reportData = reportData;
function reportDel(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.ReportDelRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('ReportDel', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.ReportDelRs.fromObject(res)];
            }
        });
    });
}
exports.reportDel = reportDel;
function getReportData(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.DataRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('Data', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.DataRs.fromObject(res)];
            }
        });
    });
}
exports.getReportData = getReportData;
function dateFormats(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.DateFormatsRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('DateFormats', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.DateFormatsRs.fromObject(res)];
            }
        });
    });
}
exports.dateFormats = dateFormats;
function reportColumns(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.ReportColumnsRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('ReportColumns', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.ReportColumnsRs.fromObject(res)];
            }
        });
    });
}
exports.reportColumns = reportColumns;
function cancelReport(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.ReportCancelRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('ReportCancel', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.ReportCancelRs.fromObject(res)];
            }
        });
    });
}
exports.cancelReport = cancelReport;
function NumericFormats(req) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    obj = nform_1.priority.netitems.nrest.NumericFormatsRq.toObject(req);
                    body = JSON.stringify(obj);
                    return [4 /*yield*/, sendHttpRequest('NumericFormats', body, req.Properties)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.NumericFormatsRs.fromObject(res)];
            }
        });
    });
}
exports.NumericFormats = NumericFormats;
